export const getItems = (t?: any) => [
  {
    title: t?.helpHighlightReel || 'Highlight Reel',
    icon: 'GalleryHorizontal',
    description: t?.helpReelText || 'Open to navigate through the Space using thumbnail images',
  },
  {
    title: t?.dollhouseView || 'Dollhouse View',
    icon: 'mp-dollhouse',
    description:
      t?.helpDollhouseText || 'Click to view and rotate a top-down view of the entire Space in 3D',
  },
  {
    title: t?.helpFloorSelector || 'Floor Selector',
    icon: 'faLayerGroup',
    description: t?.helpFloorsText || 'Switch between floors in the Space',
  },
  {
    title: t?.helpMattertagPosts || 'Mattertag™ Posts',
    icon: 'CircleDot',
    description:
      t?.helpMattertagText || 'Click or hover over for information about features in the Space',
  },
  {
    title: t?.helpTourControls || 'Tour Controls',
    icon: 'CirclePlay',
    description:
      t?.helpTourText || 'Play, pause, and navigate forward and backward through a Guided Tour',
  },
  {
    title: t?.helpInside || 'Inside View',
    icon: 'PersonStanding',
    description: t?.helpInsideText || 'Click to explore inside the Space',
    width: '25px',
  },
  {
    title: t?.helpVr || 'VR Mode',
    icon: 'RectangleGoggles',
    description: t?.helpVrText || 'Click to launch the Space in virtual reality',
  },
  {
    title: t?.helpView360 || '360° Views',
    icon: 'https://static.treedis.com/nav-images/nav_help_360.png',
    description:
      t?.helpView360Text || 'Click 360 Views in the Highlight Reel to view outdoor scenes',
  },
  {
    title: t?.helpFloorplan || 'Floor Plan',
    icon: 'mp-floorplan',
    description: t?.helpFloorplanText || 'Click to view the floor plan of the Space',
  },
  {
    title: t?.helpFscreen || 'Full screen',
    icon: 'faExpand',
    description: t?.helpFscreenText || 'Expand 3D Showcase to full screen',
  },
];
